import React from 'react';
import { Helmet } from 'react-helmet-async';
import { PERSON, SITE_NAME, SITE_URL } from '../../config/seo';

function buildPersonJsonLd({ url, ogImage }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: PERSON.name,
    jobTitle: PERSON.jobTitle,
    description: PERSON.description,
    url,
    image: ogImage || PERSON.image,
    sameAs: PERSON.sameAs,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Gurgaon',
      addressRegion: 'Haryana',
      addressCountry: 'IN',
    },
  };
}

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.description
 * @param {string} [props.canonicalPath] path only, e.g. "/" or "/yogesh-singh"
 * @param {string} [props.ogImage] absolute image URL
 * @param {string} [props.robots] default "index, follow"
 * @param {string} [props.ogType] Open Graph type
 */
export default function SEO({
  title,
  description,
  canonicalPath = '/',
  ogImage,
  robots = 'index, follow',
  ogType = 'website',
}) {
  const path = canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`;
  const canonicalUrl = SITE_URL
    ? `${SITE_URL}${path === '/' ? '' : path}`
    : path === '/'
      ? '/'
      : path;
  const imageUrl =
    ogImage ||
    (SITE_URL
      ? `${SITE_URL}/yogesh-singh-frontend-developer.png`
      : '/yogesh-singh-frontend-developer.png');
  const jsonLd = buildPersonJsonLd({ url: canonicalUrl, ogImage: imageUrl });

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <meta name="author" content={SITE_NAME} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:creator" content="@Yogesh__Dev" />

      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
